import { TableConfig } from '@shared/interfaces/table/table-config';
import { DashboardQueryMissingMeteredDataResultDto } from '@app/api/dmc';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { addressPartial, meterNumberPartial } from '@shared/columns/meteringpoint.columns';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';

export const missingMeteredDataTable: TableConfig<DashboardQueryMissingMeteredDataResultDto> = {
  id: 'missing-meteredata-table',
  title: 'dashboard.timeseries.missing.title',
  saveChanges: true,
  exportable: true,
  floatingHeader: true,
  pagination: true,
  selectable: true,
  columnSelection: true,
  pageSize: 50,
  pageSizeSelection: true,
  pageSizeOptions: [
    { key: '25', value: '25' },
    { key: '50', value: '50' },
    { key: '100', value: '100' },
    { key: '250', value: '250' },
    { key: '500', value: '500' },
  ],
  columns: [
    {
      title: 'dashboard.timeseries.missing.dateofwork',
      key: 'dayOfWork',
      width: 95,
      cellRenderer: DateCellComponent
    },
    {
      title: 'dashboard.timeseries.missing.meteringpointid',
      key: 'meteringPointIdentification',
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/meteringpoint',
        urlReference: 'meteringPointIdentification',
      }
    },
    meterNumberPartial,
    addressPartial,
    meteringPointTypePartial,
    {
      title: 'dashboard.timeseries.missing.meterreadingoccurrence',
      key: 'meterReadingOccurrence',
      cellRenderer: TranslateCellComponent,
      width: 100,
      cellRendererParams: {
        'notspecified': 'enum.resolution.notspecified',
        'year': 'enum.resolution.year',
        'month': 'enum.resolution.month',
        'day': 'enum.resolution.day',
        'hour': 'enum.resolution.hour',
        'quarter': 'enum.resolution.quarter',
      }
    },
    {
      title: 'dashboard.timeseries.missing.estimationgroup',
      key: 'estimationGroupName'
    },
    {
      title: 'dashboard.timeseries.missing.missingdatastatus',
      key: 'missingDataStatus',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        'calculationfailed': 'enum.missingdatastatus.calculationfailed',
        'calculationresolutionmismatch': 'enum.missingdatastatus.calculationresolutionmismatch',
        'estimatedvalues': 'enum.missingdatastatus.estimatedvalues',
        'estimationcandidate': 'enum.missingdatastatus.estimationcandidate',
        'estimationfailed': 'enum.missingdatastatus.estimationfailed',
        'failedaddmetereddata': 'enum.missingdatastatus.failedaddmetereddata',
        'infinitecalculationloop': 'enum.missingdatastatus.infinitecalculationloop',
        'missingcalculationrequirement': 'enum.missingdatastatus.missingcalculationrequirement',
        'missingdatareceived': 'enum.missingdatastatus.missingdatareceived',
        'missingestimationgroup': 'enum.missingdatastatus.missingestimationgroup',
        'missingformula': 'enum.missingdatastatus.missingformula',
        'missingvalues': 'enum.missingdatastatus.missingvalues',
        'needscalculation': 'enum.missingdatastatus.needscalculation',
        'notspecified': 'enum.missingdatastatus.notspecified',
        'reestimationcandidate': 'enum.missingdatastatus.reestimationcandidate',
        'sendfailed': 'enum.missingdatastatus.sendfailed',
        'validationerror': 'enum.missingdatastatus.validationerror'
      }
    },
    {
      title: 'dashboard.timeseries.missing.errormessage',
      key: "errorMessage"
    },
    {
      title: 'dashboard.timeseries.missing.comment',
      key: 'comment',
      width: 220
    }
  ],
}
